import { render, staticRenderFns } from "./base-echart.vue?vue&type=template&id=72839046&scoped=true&"
import script from "./base-echart.vue?vue&type=script&lang=js&"
export * from "./base-echart.vue?vue&type=script&lang=js&"
import style0 from "./base-echart.vue?vue&type=style&index=0&id=72839046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72839046",
  null
  
)

export default component.exports